import { useEffect, useState } from "react";

const TARGET = new Date("2026-11-20T00:00:00+05:30").getTime();

export const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = TARGET - now;
  return {
    live: diff <= 0,
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
  };
}

export default function Countdown() {
  const { live, days, hours, minutes, seconds } = useCountdown();

  if (live) {
    return (
      <div data-testid="countdown-live" className="inline-block border border-[#D4AF37]/40 bg-[#08080A]/60 px-8 py-5 backdrop-blur-sm">
        <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-[#B39343] mb-2">The Wait Is Over</p>
        <p className="font-display text-2xl sm:text-3xl font-bold text-gold-sheen">The Festival Is Live</p>
      </div>
    );
  }

  const units = [
    [days, "Days"],
    [hours, "Hours"],
    [minutes, "Minutes"],
    [seconds, "Seconds"],
  ];

  return (
    <div data-testid="hero-countdown">
      <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-[#B39343] mb-3">The Game Begins In</p>
      <div className="inline-flex items-stretch border border-[#D4AF37]/25 bg-[#08080A]/60 backdrop-blur-sm">
        {units.map(([value, label], i) => (
          <div key={label} className={`px-4 sm:px-7 py-4 text-center ${i > 0 ? "border-l border-[#D4AF37]/25" : ""}`}>
            <p data-testid={`countdown-${label.toLowerCase()}`} className="font-display text-3xl sm:text-4xl font-bold text-[#F6F4EE] tabular-nums leading-none">
              {pad(value)}
            </p>
            <p className="mt-2 font-mono text-[9px] uppercase tracking-[0.3em] text-[#B39343]">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
